import { utcDate } from './date';

/**
 * When a call happens, said once for the whole product: the dashboard's line
 * over Today and the main page's masthead read the same ladder, so a call can
 * never be two different Wednesdays depending on which page you are standing on.
 *
 * Minutes while they are worth counting, then a clock time; a weekday until it
 * goes ambiguous a week out, then a date. Today carries no word of its own —
 * "at 15:00" is today by default, and both callers say so in their own sentence.
 */
export function callWhen(start: Date | number | string, now: number, timezone: string): string {
  const at = utcDate(start).tz(timezone);
  const mins = Math.round((at.valueOf() - now) / 60_000);
  if (mins <= 0) return 'now';
  if (mins < 90) return `in ${mins} ${mins === 1 ? 'minute' : 'minutes'}`;

  const time = `at ${at.format('HH:mm')}`;
  const days = at.startOf('day').diff(utcDate(now).tz(timezone).startOf('day'), 'day');
  if (days <= 0) return time;
  if (days === 1) return `tomorrow ${time}`;
  return days < 7 ? `${at.format('dddd')} ${time}` : `on ${at.format('MMM D')} ${time}`;
}

/**
 * The zone as a person spells it, named once per screen: under the rail's hours
 * (`SlotPicker`), or in the intro card's headline over them (`intro-copy`).
 */
export function zoneName(timezone: string): string {
  // The IANA id, minus its underscores: "America/New_York" is a machine's
  // spelling, and this line is read by a person.
  return timezone.replace(/_/g, ' ');
}
